export const CrossIcon = ({ className = "w-5 h-5", strokeWidth }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M13.6 2h-3.2v5.6H4.8v3.2h5.6V22h3.2V10.8h5.6V7.6h-5.6V2z" />
  </svg>
);
